import { put } from "redux-saga/effects";
import { getClinic, getOneClinic } from "../../Services";

export function* GetClinicSaga(action) {
  const payload = action.payload;
  try {
    const res = yield getClinic(payload);
    yield put({ type: "REQ_GET_CLINIC_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_CLINIC_FAILED", errData: e });
  }
}

export function* getOneClinicSaga(action) {
  const payload = action.payload;
  try {
    const res = yield getOneClinic(payload);
    yield put({ type: "REQ_GET_ONE_CLINIC_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_ONE_CLINIC_FAILED", errData: e });
  }
}
